import {AfterViewInit, Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AcTab, DIALOG_CONFIG} from 'ac-infra';
import * as _ from 'lodash';
import {PrepareRuleDataService} from './services/prepare-rule-data.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'routing-rules-dialog',
  templateUrl: './routing-rules-dialog.component.html',
  styleUrls: ['./routing-rules-dialog.component.scss']
})
export class RoutingRulesDialogComponent implements OnInit, AfterViewInit {

  rule;
  groupName;
  externalData;
  conf;

  @ViewChild('mapForm') mapForm: NgForm;
  isRoutingActionsValid = true;
  isAdvanceConditionValid = true;
  isSipHeaderValid = true;
  isTagValid = true;


  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private prepareRuleDataService: PrepareRuleDataService) {
    const ruleData = this.dialogConfig.dialogData.ruleData;
    this.groupName = ruleData.groupName;
    this.externalData = this.dialogConfig.dialogData.externalData;
    this.conf = dialogConfig;

    this.rule = {};
    this.prepareRuleDataService.convertRuleFromServerToDialog(this.rule, ruleData.rule, this.externalData);

    this.dialogConfig.preSubmit = () => {
      this.isTagValid = true;
      this.isSipHeaderValid = true;
      this.isRoutingActionsValid = true;
      this.isAdvanceConditionValid = true;
      if (_.isArray(this.rule.action.actions) && this.rule.action.actions.length > 0) {
        for (let i = 0; i < this.rule.action.actions.length; i++) {
          if (this.checkActionItemHasInvalidCombinedSelection(this.rule.action.actions[i].actions, i)) {
            this.isRoutingActionsValid = false;
          }

          if (this.actionItemHasInvalidPercentage(this.rule.action.actions[i].actions)) {
            this.isRoutingActionsValid = false;
          }
        }
      } else {
        this.isRoutingActionsValid = false;
      }

      this.ruleAdvanceConditionIsNotValid();

      this.checkIfCustomersValid();

      if (!this.isRoutingActionsValid || !this.isAdvanceConditionValid){
        return Promise.reject(false);
      }

      return true;
    };
  }

  ngOnInit(): void {
  }

  switchAdminState(): void {
    this.rule.adminStateBoolean = !this.rule.adminStateBoolean;
    _.isEqual(this.rule.adminState, 'LOCKED') ? this.rule.adminState = 'UNLOCKED' : this.rule.adminState = 'LOCKED';
  }

  switchTestMode(): void {
    this.rule.testModeBoolean = !this.rule.testModeBoolean;
    _.isEqual(this.rule.testMode, 'LOCKED') ? this.rule.testMode = 'UNLOCKED' : this.rule.testMode = 'LOCKED';
  }

  onTabSelect($event: AcTab): void {
  }

  private isCustomersInvalid(ruleToEdit): boolean {
    return !ruleToEdit.allDestCustomers &&
      (_.isNil(ruleToEdit.destCustomers) || _.isEmpty(ruleToEdit.destCustomers)) &&
      ruleToEdit.actions.some((action) => action.customerNormalizationSIPHeader);
  }

  ngAfterViewInit(): void {
    this.mapForm.form.statusChanges.subscribe(() => {
      this.conf.submitButtonDisabled = !this.mapForm.form.valid;
    });
  }

  private checkActionItemHasInvalidCombinedSelection(actionItem, ruleIndex): boolean {
    const nonDiscardActions = actionItem.filter((item) => {
      return item.discard === false && item.continueWithNodeInternalTables === false && item.registeredUsers === false;
    });

    for (let i = 0; i < nonDiscardActions.length; i ++) {
      if ((!nonDiscardActions[i].combined || !nonDiscardActions[i].combined.id) && !nonDiscardActions[i].loopback) {
        return true;
      }

      if (nonDiscardActions[i].srcNormalizationGroup && !nonDiscardActions[i].srcNormalizationFromHeader &&
        !nonDiscardActions[i].srcNormalizationPAIHeader && !nonDiscardActions[i].srcNormalizationPPIHeader) {
        return true;
      }
    }

    return false;
  }

  private actionItemHasInvalidPercentage(actionItem): boolean {
    let percentageSummary = 0;
    let haveZeroPercentage = false;

    actionItem.forEach((item) => {
      percentageSummary =  percentageSummary + item.percentage;
      haveZeroPercentage = item.percentage <= 0 ? true : haveZeroPercentage;
    });
    return  actionItem.length === 0 || haveZeroPercentage || (percentageSummary !== 100 && !actionItem[0].isEquallyBalanced);
  }

  private ruleAdvanceConditionIsNotValid(): void {
    if (!this.rule.isTrigger3xx && !this.rule.isTriggerRefer && !this.rule.isTriggerInitialOnly &&
      !this.rule.isTriggerBrokenConnection && !this.rule.isTriggerFaxRerouting) {
      this.isAdvanceConditionValid = false;
    }
    if (this.rule.isActionDirective && !this.rule.isActionDirectiveAllow && !this.rule.isActionDirectiveBlock &&
      !this.rule.isActionDirectiveRedirect) {
      this.isAdvanceConditionValid = false;
    }
    if ((this.rule.tags.length > 0) && this.tagsPropertiesAreInvalid()) {
      this.isAdvanceConditionValid = false;
      this.isTagValid = false;
    }
    if (this.rule.sipHeaders.length > 0  && this.sipHeadersPropertiesAreInvalid()){
      this.isAdvanceConditionValid = false;
      this.isSipHeaderValid = false;
      }
  }

  private tagsPropertiesAreInvalid(): boolean{
    return this.rule.tags.some(item => {
      return ( (!item.tag && item.value.length > 0) || (item.tag && item.value.length === 0) ); });
  }

  private sipHeadersPropertiesAreInvalid(): boolean{
    return this.rule.sipHeaders.some(item => {
      return ( (item.name === '' && item.value.length > 0) || (item.name !== '' && item.value.length === 0) ); });
  }

  private checkIfCustomersValid(): void {
    const ruleToEdit: any = this.prepareRuleDataService.convertRuleFromDialogToServer(this.rule);

    if (this.isCustomersInvalid(ruleToEdit)) {
      ruleToEdit.actions.forEach(action => action.customerNormalizationSIPHeader = false);
    }

    this.dialogConfig.dialogData.ruleToEdit = ruleToEdit;
  }
}
